import React, { useState, useEffect, useContext } from "react";
import BasicSelect from "../select/select";
import TopBar from "../../scenes/global/Top-Bar";
import { TextArea } from "../textarea/textarea";
import SideBar from "../../scenes/global/Side-Bar";
import Tab from "../tab/tab";
import Months from "../../scenes/step/data/month";
import { dispatchVoluntary, generate_my_cv } from "../../Redux/ActionCreator";
import { useSelector, useDispatch } from "react-redux";
import AddedItem from "../added_item/added_item";
import AddMore from "../add_more/add_more";
import $ from "jquery";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { ToastContainer, toast } from "react-toastify";
import { LanguageContext } from "../../scenes/global/languageContext";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

export default function UserVolunteerExperience(props) {
  const { language, handleLanguageChange } = useContext(LanguageContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const voluntary = useSelector((vol) => vol.voluntary);
  const [chips, setChips] = useState(props.volunteer);
  const generated = useSelector((e) => e.generateCV);
  const profile1 = useSelector((e) => e.login);
  let stat = profile1.profile_status.profile_status;
  const cv = useSelector((prev) => prev.cvId);
  const [volunteer, setVolunteer] = useState([]);
  const [volStartDate, setVolStartDate] = useState("");
  const [volEndDate, setVolEndDate] = useState("");
  const [obj, setObj] = useState();

  let year = [];
  for (let i = 1990; i <= 2023; i++) {
    year.push(`${i}`);
  }
  let month = [];
  for (let i = 0; i <= Months.length - 1; i++) {
    month.push(`${Months[i].value}`);
  }

  useEffect(() => {
    if (obj !== undefined) {
      dispatch(generate_my_cv(obj));
    }
  }, [obj]);

  useEffect(() => {
    if (voluntary.voluntary !== null) {
      setChips(voluntary.voluntary);
      setVolunteer(voluntary.voluntary);
    }
  }, [voluntary.voluntary]);
  console.log("volunteer", props);

  const handleAdd = () => {
    const date1 = new Date(volStartDate);
    const date2 = new Date(volEndDate);

    const month1 = date1.toLocaleDateString("en-US", { month: "short" });
    const year1 = date2.getFullYear();

    const Volunteer_Org = $('[name="vol"]').val();
    const Volunteer_join_date = month1 + " " + year1;
    let newVol = volunteer;
    let k = volunteer?.length;
    const data = {
      key: k,
      Volunteer_Org: Volunteer_Org,
      Volunteer_join_date: Volunteer_join_date,
    };
    newVol.push(data);
    setVolunteer(newVol);
    setChips(newVol);
    dispatch(dispatchVoluntary(newVol));
    $('[name="vol"]').val("");
    setVolStartDate("");
    setVolEndDate("");
    $('[name="volMonth"]').val("");
    $('[name="volYear"]').val("");
  };

  let mth = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  const handleClickOperation = (desiredKey) => {
    let v = volunteer;
    let desiredObject = v.find((item) => item.key === desiredKey.key);
    let w = v.filter((chip) => chip.key !== desiredObject.key);

    $('[name="vol"]').val(desiredObject.Volunteer_Org);
    // $('[name="work_place"]').val(desiredObject.Where_i_worked_location);

    const startMonth = desiredObject.Volunteer_join_date.split(" ")[0];
    const startYear = desiredObject.Volunteer_join_date.split(" ")[1];

    const firstMonth = new Date(startYear, mth.indexOf(startMonth));
    const firstYear = new Date(startYear);
    let i = firstMonth.getTime();
    let y = firstYear.getTime();
    console.log("Milli", i);
    console.log("Mil year", y);
    setVolStartDate(i);
    setVolEndDate(y);

    console.log("desired object", desiredObject);
    w.forEach((element) => {
      element.key = w.indexOf(element);
      console.log("vol key", w.indexOf(element));
    });
    setVolunteer(w);
    setChips(w);
    dispatch(dispatchVoluntary(w));
    desiredObject = [];

    console.log("inner chips", chips);
    console.log("inner volunteer", w);
  };

  // handleClick function
  const handleClick = (desiredKey) => {
    const volun = $('[name="vol"]').val();
    if (volun !== "") {
      handleAdd(); // add already mapped values back to the work array if the client/user forget to click add, this is so, so as to save users experience.
      handleClickOperation(desiredKey);
    } else {
      handleClickOperation(desiredKey);
    }
  };

  const handleDelete = (chipToDelete) => {
    const newvol = volunteer.filter((element) => {
      if (element.key !== chipToDelete.key) return element;
    });
    console.log("new volunteer", newvol);
    newvol.forEach((element) => {
      element.key = newvol.indexOf(element);
    });
    setVolunteer(newvol);
    setChips(newvol);
    dispatch(dispatchVoluntary(newvol));
    console.log("chips", chips);
    console.log("delete cert", volunteer);
  };

  const handleBackBtn = () => {
    if ($('[name="vol"]').val() !== "") {
      setTimeout(() => {
        toast.error("Add the volunteer you just filled.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }, 50);
    } else {
      props.handleStepChangeBack();
    }
  };

  const handleNextBtn = () => {
    if (window.location.pathname === `/form/${cv.id}/update`) {
      if ($('[name="vol"]').val() !== "") {
        handleAdd();
      }
      let generated_value = generated.message;
      generated_value.Volunteer = volunteer;
      setObj(generated_value);
      navigate("/allCv");
    } else {
      if ($('[name="vol"]').val() !== "") {
        setTimeout(() => {
          toast.error("Add the volunteer you just filled.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }, 50);
      } else {
        props.handleStepChange();
      }
    }
  };

  return (
    <div className="grid grid-cols-auto md:grid-cols-smdash cont:grid-cols-dash grid-rows-dash">
      <TopBar topBarShowMenu={true} />
      <SideBar />
      <div className="md:ScollOnly md:h-calc-70 md:overflow-y-scroll">
        <div className="px-3 py-8 w-full pl-3 sm:pl-6 lg:pl-9 xl:pl-12 max-w-[800px] xl:max-w-calculate">
          <div className="w-full h-[54px] bg-white bg-opacity-50 rounded-[40px] shadow border border-indigo-400 border-opacity-30 flex flex-col justify-center">
            <p className="text-stone-950 text-base md:text-[28px] font-semibold ml-12 max-[300px]:ml-6">
              {language["resume_caph1"]}
            </p>
          </div>
          <p className="w-full mt-2">
            <span className="text-black text-opacity-50 text-[14px] md:text-base font-normal px-3 lg:pl-6">
              {language["Hey_there"]}
            </span>
          </p>
          <div className="w-full mt-8 p-8 bg-white bg-opacity-80 rounded-2xl shadow border border-indigo-400 border-opacity-30 flex-col justify-start items-start gap-16 inline-flex">
            <div className="tabarea justify-start items-center gap-6 inline-flex w-full flex-shrink-0 w-full max-w-[calc(100vw-88px)] overflow-hidden">
              <Tab
                num="1"
                current={false}
                completed={true}
                className="max-[420px]:hidden"
              />
              <Tab
                num="2"
                current={false}
                completed={true}
                className="max-[420px]:hidden"
              />
              <Tab
                num="3"
                current={false}
                completed={true}
                className="max-[350px]:hidden"
              />
              <Tab num="4" current={false} completed={true} />
              <Tab
                // label="Volunteer Experience"
                label={`${language["volunteer_experience"]}`}
                current={true}
                completed={false}
              />
              <Tab num="6" current={false} completed={false} />
              <Tab num="7" current={false} completed={false} />
              <Tab num="8" current={false} completed={false} />
              <Tab num="9" current={false} completed={false} />
            </div>
            <div className="flex-col justify-start items-start gap-12 flex w-full">
              <div className="flex-col justify-start items-start gap-2 flex w-full">
                <div className="flex gap-3 items-center">
                  <div className="px-1 w-2 h-2 rounded-full bg-black"></div>
                  <label
                    className="text-black text-base font-medium"
                    for="volunteerOrg"
                  >
                    {language["voluteer_org"]}
                  </label>
                </div>
                <input
                  type="text"
                  className="p-4 w-full rounded-lg border border-indigo-400 border-opacity-30"
                  placeholder={`${language["ogarnization_place"]}`}
                  id="volunteerOrg"
                  name="vol"
                />
              </div>
              {/* <div className="w-full flex flex-col gap-3">
              <div className="flex gap-3 items-center">
                <div className="px-1 w-2 h-2 rounded-full bg-black"></div>
                <label
                  className="text-black text-base font-medium"
                  for="volunteerDesc"
                >
                  What did you do there?
                </label>
              </div>
              <div className="">
                <TextArea placeholder="0/300" id="volunteerDesc"/>
              </div>
            </div> */}
              <div className="flex-col justify-start items-start gap-2 flex w-full">
                <div className="flex gap-3 items-center">
                  <div className="px-1 w-2 h-2 rounded-full bg-black"></div>
                  <label
                    className="text-black text-base font-medium"
                    for="volunteerStartDate"
                  >
                    {language["when_voluteer"]}
                  </label>
                </div>
                <div className="w-full flex flex-col sm:flex-row gap-2">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer
                      components={["DatePicker", "DatePicker", "DatePicker"]}
                    >
                      <DatePicker
                        label={`${language["month_place"]}`}
                        views={["month"]}
                        value={dayjs(volStartDate)}
                        onChange={(event) => setVolStartDate(event)}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer
                      components={["DatePicker", "DatePicker", "DatePicker"]}
                    >
                      <DatePicker
                        label={`${language["year_place"]}`}
                        name="startYear"
                        views={["year"]}
                        value={dayjs(volEndDate)}
                        onChange={(endValue) => setVolEndDate(endValue)}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </div>
                {/*               <div className="w-full h-[54px] flex gap-3">
                <BasicSelect
                  placeholder="Month"
                  labelId="Month"
                  selectMenu="volMonth"
                  id="volunteerStartDate"
                  menuItems={[ ...month ]}
                  width="lg"
                />
                <BasicSelect
                  placeholder="Year"
                  labelId="Year"
                  selectMenu="volYear"
                  id="volunteerStartDate"
                  menuItems={[ ...year ]}
                  width="lg"
                />
              </div> */}
                <div className="flex-col justify-start items-start gap-3 flex w-full">
                  <AddMore text="volunteer" onClick={handleAdd} />
                  <p className="text-black text-base font-medium">
                    {language["have_added"]}
                  </p>
                  <div className="flex flex-wrap gap-3">
                    {chips?.map((vol, key) => (
                      <AddedItem
                        item={vol.Volunteer_Org}
                        key={key}
                        onClick={() => handleClick(vol)}
                        delete={() => handleDelete(vol)}
                      />
                    ))}
                  </div>
                </div>
                {/* <div className="w-full flex flex-col gap-3">
              <div className="flex gap-3 items-center">
                <div className="px-1 w-2 h-2 rounded-full bg-black"></div>
                <label
                  className="text-black text-base font-medium"
                  for="voulnteerAchievement"
                >
                  What did you achieve or learn during your time there?
                </label>
              </div>
              <div className="">
                <TextArea placeholder="0/300" id="voulnteerAchievement"/>
              </div>
            </div> */}
              </div>
              <div className="self-stretch flex-col sm:flex-row justify-between items-start gap-4 inline-flex">
                <button
                  className="px-5 py-3 rounded-lg shadow border border-orange-500 justify-center items-start gap-2.5 flex w-full sm:max-w-[200px]"
                  onClick={handleBackBtn}
                >
                  <span className="text-center text-orange-500 text-base font-semibold">
                    {language["previous_btn"]}
                  </span>
                </button>
                <button
                  className="px-5 py-3 bg-indigo-700 rounded-lg shadow justify-center items-start gap-2.5 flex w-full sm:max-w-[200px]"
                  onClick={handleNextBtn}
                >
                  <span className="text-center text-white text-base font-semibold whitespace-nowrap">
                    {language["save_n_continue"]}
                  </span>
                </button>
              </div>
              <button
                className="flex gap-2 items-center px-5 py-2.5"
                onClick={props.handleStepChange}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.5 4C12.5 3.86739 12.4473 3.74021 12.3536 3.64645C12.2598 3.55268 12.1326 3.5 12 3.5C11.8674 3.5 11.7402 3.55268 11.6464 3.64645C11.5527 3.74021 11.5 3.86739 11.5 4V7.248L5.233 3.612C4.713 3.31 4 3.655 4 4.308V11.692C4 12.345 4.713 12.69 5.233 12.388L11.5 8.752V12C11.5 12.1326 11.5527 12.2598 11.6464 12.3536C11.7402 12.4473 11.8674 12.5 12 12.5C12.1326 12.5 12.2598 12.4473 12.3536 12.3536C12.4473 12.2598 12.5 12.1326 12.5 12V4ZM5 4.633L10.804 8L5 11.367V4.633Z"
                    fill="#F24E1E"
                  />
                </svg>

                <span className="text-center text-orange-500 text-base font-medium">
                  Skip this stage
                </span>
              </button>
              <ToastContainer />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
